import React, { useEffect, useState, useCallback } from "react";
import "./organization-list.scss";
import {
  GSListPage,
  GSInput,
  GSItemList,
  GSButton,
  GSEmptyList,
} from "golfstatus_react_components";
import { useDispatch, connect, useSelector } from "react-redux";
import {
  getOrganizationList,
  selectOrganizationList,
  setOrganizations,
} from "../reducers/organizationSlice";
import { faSearch, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import OrganizationLineItem from "./organization-line-item";
import { useNavigate } from "react-router-dom";
import { setNav } from "../reducers/appSlice";
import { getCurrentUser } from "../app/gs-session";
import { useIntercom } from "react-use-intercom";

const OrganizationList = (props) => {
  const { loading } = props;
  const organizationsList = useSelector(selectOrganizationList);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentUser = getCurrentUser();
  const intercom = useIntercom();
  const [filter, setFilter] = useState({
    page: {
      number: 1,
      size: 30,
    },
    include: "facility,parent-organization",
    name: "",
    email: "",
    userID: currentUser.uid,
  });
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");

  const loadNav = useCallback(() => {
    dispatch(
      setNav([
        { id: 1, label: "My Organizations", url: "/", isSelectable: true },
      ])
    );
  }, [dispatch]);

  const loadFilter = useCallback(() => {
    if (filter.page.number === 1) {
      dispatch(setOrganizations([]));
    }
    dispatch(getOrganizationList(filter));
  }, [dispatch, filter]);

  useEffect(() => {
    loadNav();
  }, [loadNav]);

  useEffect(() => {
    loadFilter();
  }, [loadFilter]);

  const getListPage = (title) => {
    const page = {
      title: title,
      getDefaultSearch: getDefaultSearch,
      getItemList: getItemList,
      loadMore: loadMore,
    };
    return <GSListPage {...page} />;
  };

  const searchChanged = (e) => {
    setName(e.target.value);
  };

  const searchEmailChanged = (e) => {
    setEmail(e.target.value);
  };

  const submitSearch = () => {
    dispatch(setOrganizations([]));
    setFilter({ ...filter, name: name, email: email });
  };

  const loadMore = () => {
    //Paging is currently not set up for organizations
    //setFilter({...filter, page: { ...filter?.page, number: filter?.page?.number + 1 }});
  };

  const clearText = () => {
    setName("");
    setFilter({ ...filter, name: "", email: email });
  };
  const clearEmailText = () => {
    setEmail("");
    setFilter({ ...filter, name: name, email: "" });
  };
  const clearSearchFields = () => {
    setName("");
    setEmail("");
    setFilter({ ...filter, name: "", email: "" });
  };
  const searching = () => {
    return name !== "" || email !== "";
  };

  const getDefaultSearch = () => {
    return (
      <div className="org-search">
        <GSInput
          textValue={name}
          leftIcon={faSearch}
          rightIconClick={clearText}
          rightIcon={faTimesCircle}
          onChange={searchChanged}
          onSubmit={submitSearch}
          placeholder="Search Organizations.."
        ></GSInput>
        <GSInput
          textValue={email}
          leftIcon={faSearch}
          rightIconClick={clearEmailText}
          rightIcon={faTimesCircle}
          onChange={searchEmailChanged}
          onSubmit={submitSearch}
          placeholder="Search by Contact Email…"
        ></GSInput>
        {searching() ? (
          <GSButton
            type="mobile-icon"
            title="clear all"
            onClick={clearSearchFields}
          ></GSButton>
        ) : null}
      </div>
    );
  };

  const getOrganizationLineItem = (organization) => {
    return <OrganizationLineItem {...organization} />;
  };

  const selectOrganization = (org) => {
    if (org?.tosAcceptedAt) {
      navigate(`/${org.id}`);
    } else {
      navigate(`/${org.id}`);
      //window.open("http://users.golfstatus.dev/app/tos")
    }
  };

  const includeOrg = (org) => {
    const { name, email } = filter;
    const oname = org?.name?.toLowerCase?.() ?? "";
    const oemail = org?.email?.toLowerCase?.() ?? "";
    const lcName = name?.toLowerCase?.();
    const lcEmail = email?.toLowerCase?.();
    return oname?.includes?.(lcName) && oemail?.includes?.(lcEmail);
  };

  const openIntercom = () => {
    intercom.show();
  };

  const contactGolfStatus = () => {
    window.open("https://golfstatus.org/demo");
  };

  const getEmptyListMessage = () => {
    return (
      <GSEmptyList
        title="Manage Organizations"
        detail="Organizations leverage GolfStatus to streamline tournament management. Schedule a demo to get started."
        actions={[
          {
            title: "Get Started",
            onClick: contactGolfStatus,
            type: "black",
          },
        ]}
      />
    );
  };
  const getEmptySearchMessage = () => {
    return (
      <GSEmptyList
        title="We couldn’t find the organization you’re looking for…"
        detail="Try changing the search term and filter or contact GolfStatus support."
        actions={[
          {
            title: "Clear All",
            onClick: clearSearchFields,
            type: "light-grey",
          },
          {
            title: "Get Help",
            onClick: openIntercom,
            type: "black",
          },
        ]}
      />
    );
  };

  const getItemList = () => {
    return (
      <GSItemList
        items={organizationsList.filter(includeOrg)}
        listItem={(organization) => getOrganizationLineItem(organization)}
        itemSelected={selectOrganization}
        type="vertical selectable"
        emptyMessage={
          filter?.name !== "" || filter?.email !== ""
            ? getEmptySearchMessage()
            : getEmptyListMessage()
        }
        loading={loading?.includes?.("getOrganizationList")}
        loadingMainText="Loading Organizations..."
        loadingSubText="This may take a moment."
      ></GSItemList>
    );
  };

  return (
    <organization-list>{getListPage("My Organizations")}</organization-list>
  );
};

const mapStateToProps = (state) => ({
  organizationsList: state.orgs.organizationList,
  loading: state.orgs.loading,
});
export default connect(mapStateToProps)(OrganizationList);
